import { BaseService } from "./BaseService";

export class ProfileService extends BaseService {
  getProfiles(): any {
    return super.invokeGet(this.APICONFIG.APIBASEURL + this.APICONFIG.GETPROFILES);
  }
}
